import axios from 'axios';

export const generateAxiosInstanceSection = () => {
  const baseURL = process.env.REACT_APP_BACKEND_SECTION_URL; // Your base URL
  const accessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  });
};

// Use this function whenever you need axiosInstance
// const axiosInstance = generateAxiosInstance();
// export default axiosInstance;

